import { MAX_ACF_BYTES } from './acf';
export async function readAcf(file, signal) {
  if (file.size > MAX_ACF_BYTES) throw new Error('Please choose an ACF smaller than 100 MB.');
  const buffer = await file.arrayBuffer();
  if (signal?.aborted) throw new DOMException('Cancelled', 'AbortError');
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('./acf.worker.js', import.meta.url), { type: 'module' });
    const cleanup = () => { worker.terminate(); signal?.removeEventListener('abort', abort); };
    const abort = () => { cleanup(); reject(new DOMException('Cancelled', 'AbortError')); };
    signal?.addEventListener('abort', abort, { once: true });
    worker.onmessage = ({ data }) => { cleanup(); data.error ? reject(new Error(data.error)) : resolve(data.result); };
    worker.onerror = (event) => {
      cleanup();
      const detail = event.message ? ` ${event.message}` : '';
      reject(new Error(`The point-cloud reader could not run.${detail} Reload the page and try again.`));
    };
    worker.postMessage(buffer, [buffer]);
  });
}
